import React from 'react'
import { WebsiteStylesSettingsLayout } from 'src/editor/layout/sidebar/website-styles-settings/website-styles-settings-layout'
import { WebsitePageInterface } from 'src/shared/types/website-entities'

export interface WebsitePageBodySettingsProps {
  entity: WebsitePageInterface
}

export const WebsitePageBodySettings = ({
  entity,
}: WebsitePageBodySettingsProps) => {
  return <WebsiteStylesSettingsLayout />
}
